var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFBaseStatusBadgeTokens, CFBaseStatusBadgeUtils, } from '@connectrn/ds-ui-base';
import { CFIcon } from '../../../components';
import { commonAttrs } from '../../../utils';
import { CFStatusBadgeElements } from './StatusBadge.styles';
export const CFStatusBadge = (_a) => {
    var { alternateTheme, colorway = 'primary', iconLeft, iconRight, label, size = 'md', strength = 'strong' } = _a, rest = __rest(_a, ["alternateTheme", "colorway", "iconLeft", "iconRight", "label", "size", "strength"]);
    const { Label, Root } = CFStatusBadgeElements;
    const renderIcon = (icon) => icon && (React.createElement(CFIcon, { color: CFBaseStatusBadgeUtils.getIconColor({
            alternateTheme,
            colorway,
            strength,
        }), size: CFBaseStatusBadgeTokens.ICON_SIZE, icon: icon }));
    return (React.createElement(Root, Object.assign({ alternateTheme: alternateTheme, colorway: colorway, size: size, strength: strength }, commonAttrs(rest)),
        renderIcon(iconLeft),
        React.createElement(Label, { alternateTheme: alternateTheme, colorway: colorway, size: size, strength: strength }, label),
        renderIcon(iconRight)));
};
